export default __webpack_public_path__ + "mask1a8aabc.png";